<template>
  <div class="container">
    <h3>Account {{ account }}</h3>
    <hr />
    <div v-if="!loading" class="row p-5">
      <div v-for="(token, idx) in tokens" :key="idx" class="col-4">
        <div>
          <img :src="token.image" style="max-width: 125px" />
        </div>
        <div>Token ID: {{ token.tokenId }}</div>
        <div>Name: {{ token.name }}</div>
        <div v-for="(attribute, $index) in token.attributes" :key="$index">
          <span v-if="attribute.display_type === 'boost_number'">
            {{ attribute.trait_type | humanize }}: ({{ attribute.value }}/{{
              attribute.max_value
            }})
          </span>
          <span v-else>
            {{ attribute.trait_type | humanize }}: {{ attribute.value }}
          </span>
        </div>
        <div>
          <button
            class="button-upgrade"
            @click.prevent="redirectToUpgrade(token)"
          >
            Upgrade
          </button>
        </div>
      </div>
    </div>
    <h2 v-else>Loading tokens...</h2>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ApiService from "@/services/ApiService";
import router from "../router/index";

export default {
  name: "Account",
  computed: {
    ...mapGetters(["account", "chain"]),
  },
  data() {
    return {
      tokens: [],
      loading: true,
    };
  },
  methods: {
    async getTokens() {
      this.tokens = await ApiService.getAccountTokens(
        this.chain.chainId,
        this.account
      );
      this.loading = false;
    },
    redirectToUpgrade(token) {
      console.log("Selected:" + JSON.stringify(token));
      this.$store.state.characterTypeId = token.tokenId;
      router.push({ path: "/character-upgrade"})
    },
  },
  watch: {
    account(newVal) {
      console.log("WATCH::::0")
      if (newVal) {
        console.log("WATCH::::1")
        this.getTokens();
      }
    },
  },
};
</script>

<style scoped>
</style>
